import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { isFullyAuthenticated } from "../../utils/helpers/authCookies";
import EmptyStateImg from "../../assets/images/empty-state-riskcases.svg";

const NotFound = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const isAuthenticated = isFullyAuthenticated(userLogin?.userInfo);
  const homePath = isAuthenticated ? "/" : "/signin";
  const homeLabel = isAuthenticated ? "Go to dashboard" : "Go to sign in";

  return (
    <Stack
      gap="16px"
      height="100vh"
      alignItems="center"
      justifyContent="center"
      maxWidth="646px"
      width="100%"
      margin="0 auto"
      padding={2}
    >
      <Box width="200px" height="auto">
        <img src={EmptyStateImg} alt="Page not found" width="100%" />
      </Box>
      <Typography variant="h1" fontWeight="500" fontSize="3.8rem">
        404
      </Typography>
      <Typography
        variant="body1"
        fontSize="2rem"
        textAlign="center"
        color="#566875"
      >
        The page you are looking for does not exist or may have been moved.
      </Typography>
      <Button
        size="large"
        variant="contained"
        component={RouterLink}
        to={homePath}
        sx={{ textTransform: "initial" }}
      >
        {homeLabel}
      </Button>
    </Stack>
  );
};

export default NotFound;
